/* ==========================================================================
   LoadingInformationRxjs > Client > Image
   ========================================================================== */

/* Modules */
const Image = require('../../../../image-rxjs/client/js');

/* Init image */
function initImage(instance) {
    /* Data */
    const { hasImage } = instance.config;

    if (!hasImage) return;

    const inst = instance;

    const { selector } = instance;

    inst.image = Image(`${selector} [data-component='ImageRxjs']`);
}

/* Destroy image */
function destroyImage(instance) {
    /* Data */
    const { hasImage } = instance.config;

    if (!hasImage) return;

    const int = instance;

    instance.image.actions.destroy();

    delete int.image;
}

/* Exports */
module.exports = {
    initImage,
    destroyImage
};
